// extracted by mini-css-extract-plugin
export var cardHeader = "_fj-0";
export var reorderHandle = "_fj-3";
export var titleArea = "_fj-1";
export var titleAreaWithHandle = "_fj-2";